<template>
    <div @click="close" style="background-color: #00000080; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div style="width: 300px; background-color: #fff; border-radius: 20px; padding: 28px 19px; text-align: center; font-weight: 700; ">
            <div style="color: var(--color-main);">{{title}}</div>
            <div style="font-size: 20px; line-height: 32px; margin-top: 8px;">{{ $GlobalStore.loginInfo().nic_name }}님,<br/>새로운 훈련 과제가 도착했어요</div>
            <div style="font-size: 12px; margin-top: 8px; color: #606060;">미션 성공하면 포인트 보상 지급!</div>
            <div style="text-align: center; margin-top: 8px;">
                <transition-group name="fade-scale" tag="div" class="img-wrapper">
                    <img v-if="!isOpenAssignment" key="close" class="img-fade" :src="require('@/assets/img/new_assignment_close.png')"
                    />
                    <img v-else key="open" class="img-fade" :src="require('@/assets/img/new_assignment_open.png')"
                    />
                </transition-group>
            </div>
            <div @click.stop="close" style="height: 52px; margin-top: 36px; border-radius: 12px; background-color: var(--color-main); line-height: 52px; color: #fff; font-weight: 500; text-align: center;">확인하기</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewTrainingVideoPopup',
        props : {
            banner : {
                type : Object,
                default : () => {}
            }
        },
        data() {
            return {
                isOpenAssignment: false
            }
        },
        computed : {
            title(){
                const contents = this.banner.contents;

                const contents_arr = contents.split('|||');
                if(contents_arr.length > 0){
                    return contents_arr[0];
                }
                return '';
            }
        },
        created() {
            setTimeout(() => {
                this.isOpenAssignment = true
            }, 1000);
        },
        methods: {
            close(){
                const TRAINING_BANNER_POPUP_IDXES = 'TRAINING_BANNER_POPUP_IDXES';
                
                let training_banner_popup_idxes = null;
                
                if(this.$hasOwnProperty(localStorage, TRAINING_BANNER_POPUP_IDXES)){
                    training_banner_popup_idxes = JSON.parse(localStorage.getItem(TRAINING_BANNER_POPUP_IDXES));
                }else {
                    training_banner_popup_idxes = {};
                }
                training_banner_popup_idxes[this.banner.idx] = true;
                localStorage.setItem(TRAINING_BANNER_POPUP_IDXES, JSON.stringify(training_banner_popup_idxes));
                
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.addModal('LearnBannerDetail', { bannerIdx: this.banner.idx, isModalBackTransparent: true, })
            }
        }
    }
</script>

<style scoped>

.img-wrapper {
  position: relative;
  height: 138px;
}

.img-fade {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 132px;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 1s ease;
}

.fade-scale-enter {
  opacity: 0;
}
.fade-scale-leave-to {
  opacity: 0;
}
</style>